import { generateId } from '../../utils';

/**
 * Generates an invalid content ID that can be used to persist database drafts that are not saved yet
 * in the redux store.
 */
export function generateVirtualContentId(): string {
  return generateId();
}

/**
 * Returns true if the given content ID is a virtual ID created by generateVirtualContentId() rather than
 * a real content ID.
 */
export function isVirtualContentId(contentId: string): boolean {
  return contentId.includes('-');
}
